import React from 'react';
import { Button, Typography } from '@mui/material';

import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import useMobile from 'services/Hooks/useMobile';
import { ApplicationIcons } from 'icons/ApplicationIcons';
import { useSelector } from 'react-redux';
import { useDealerPortalMenuTree } from 'services/Data/DealerPortalMenuServices';
import { DealerPortalSectionEnumValue, getDealerPortalSectionName } from 'enums/DealerPortalSectionEnum';

const getOrderedChildren = menuNode => {
  if (Array.isArray(menuNode?.children)) {
    return [...menuNode.children].sort((left, right) => Number(left?.order ?? 0) - Number(right?.order ?? 0));
  }

  if (Array.isArray(menuNode?.Children)) {
    return [...menuNode.Children].sort((left, right) => Number(left?.order ?? 0) - Number(right?.order ?? 0));
  }

  return [];
};

const getMenuId = menuNode => menuNode?.id || menuNode?.Id || null;

const getFirstOrderedMenuId = menuNodes => {
  const sortedNodes = [...(Array.isArray(menuNodes) ? menuNodes : [])].sort(
    (left, right) => Number(left?.order ?? 0) - Number(right?.order ?? 0),
  );

  if (sortedNodes.length === 0) {
    return null;
  }

  const firstNode = sortedNodes[0];
  const childFirstMenuId = getFirstOrderedMenuId(getOrderedChildren(firstNode));

  return childFirstMenuId || getMenuId(firstNode);
};

const QuicklinksButton = () => {
  const { t } = useTranslation();
  const accountReducer = useSelector(state => state.AccountReducer);
  const isLoggedIn = Boolean(accountReducer?.isLoggedIn);
  const { data: usefulLinksMenuTreeData } = useDealerPortalMenuTree(DealerPortalSectionEnumValue.UsefulLinks, isLoggedIn);

  const isMobile = useMobile();
  const sectionName = getDealerPortalSectionName(DealerPortalSectionEnumValue.UsefulLinks);
  const firstMenuId = getFirstOrderedMenuId(usefulLinksMenuTreeData);
  const usefulLinksRoute =
    sectionName && firstMenuId ? `/dealer/section/${sectionName}/menu/${firstMenuId}` : '/dealer/useful-links';

  return (
    <React.Fragment>
      <Button
        style={{ boxShadow: 'none' }}
        variant="contained"
        endIcon={<ApplicationIcons.UsefulLink />}
        component={NavLink}
        to={usefulLinksRoute}>
        <Typography variant="h4">{isMobile ? '' : t('usefulLink')}</Typography>
      </Button>
    </React.Fragment>
  );
};

export default QuicklinksButton;
